/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import { useInView } from 'react-intersection-observer';

import QueryString from 'qs';
import { useStore } from '@src/models';
import { ROUTES } from 'src/constants';
import { JOBS_PER_PAGE, storeEnum } from '../models/index';

const scopeFilterPathnames = [ROUTES.candidatesRoutes.learning, ROUTES.candidatesRoutes.roles, ROUTES.resources];

interface IOptions {
  customPath: string;
}

export const useJobFeed = (getJobs: (qs) => string, store: storeEnum, options: Partial<IOptions> = {}) => {
  const {
    routerStore: {
      push,
      location: { search, pathname }
    },
    feed: {
      jobs: { fetchJobs, incPage, clearData, isFetching, error, setFilter, ...params }
    }
  } = useStore();

  const jobsList = params[store];
  const isJobsFetched = params[`is${store}Fetched`];

  React.useEffect(() => {
    if (scopeFilterPathnames.find(path => path === pathname) && search.search('scope') < 0) {
      const path = [
        ROUTES.candidatesRoutes.learning,
        ROUTES.candidatesRoutes.learning + '/',
        ROUTES.resources,
        ROUTES.resources + '/'
      ].find(path => path === pathname)
        ? 'learningScope'
        : 'scope';
      const newQsObj = QueryString.parse(search, { ignoreQueryPrefix: true });

      const scope = params[path];

      const newQs = QueryString.stringify({ ...newQsObj, ...{ scope: scope.value } });

      push({
        search: newQs
      });
      return;
    }
    fetchJobs(getJobs, search, { blowPrevRes: true, store, ...options });
  }, [search]);

  const [ref, inView] = useInView({
    threshold: 0
  });
  React.useEffect(() => {
    if (inView && jobsList.length >= JOBS_PER_PAGE) {
      incPage();
      fetchJobs(getJobs, search, { store, ...options });
    }
  }, [inView]);

  return {
    ref,
    incPage,
    error,
    jobsList,
    isFetching,
    isJobsFetched
  };
};
